import React, { useMemo } from 'react'
import styles from './about.module.scss'
import Image from 'next/legacy/image'
import Section from './data'
// Images
import dogImgOne from '../../../public/landing/about-doodles/img-1.png'
import dogImgTwo from '../../../public/landing/about-doodles/img-2.png'
import dogImgThree from '../../../public/landing/about-doodles/img-3.png'
import dogImgFour from '../../../public/landing/about-doodles/img-4.png'

import miniImgOne from '../../../public/landing/about-mini/img-1.png'
import miniImgTwo from '../../../public/landing/about-mini/img-2.png'
import miniImgThree from '../../../public/landing/about-mini/img-3.png'
import miniImgFour from '../../../public/landing/about-mini/img-4.png'

// DOODLE
export const doodleParagraphs = [
  {
    title: 'What Are Examples of Doodle Breeds?',
    text: (
      <p className={styles.text}>
        A Doodle is the name of a dog or mixed breed that is a cross between a
        Poodle and another dog breed. Some of the most common Doodle breeds are:
        <br />
        <br />
        <ol>
          <li>Labradoodle (Cross of Labrador Retriever and Poodle)</li>
          <li>
            <a
              className={styles.link}
              href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/goldendoodle`}
            >
              Goldendoodle
            </a>{' '}
            (Cross of Golden Retriever and Poodle)
          </li>
          <li>Bernedoodle (Cross of Bernese Mountain Dog and Poodle)</li>
          <li>Cavapoo (Cross of Cavalier King Charles Spaniel and Poodle)</li>
          <li>Sheepadoodle (Cross of Old English Sheepdog and Poodle)</li>
        </ol>
        <br />
        Doodles have become increasingly popular amongst families. This is
        because they are typically intelligent, playful, and low-shedding.
        Poodles are an easy-to-train breed, and this trait is typically
        inherited by Doodles. This makes Doodles good companions for novice
        owners. If you are not sure which Doodle breed is right for you, check
        out our{' '}
        <a
          className={styles.link}
          href={`${process.env.NEXT_PUBLIC_ROOT_URL}/blog/doodle-comparison`}
        >
          complete comparison guide on Doodle breeds.
        </a>
      </p>
    )
  },
  {
    title: 'Are Doodles Hypoallergenic?',
    text: (
      <p className={styles.text}>
        No dog breed is truly hypoallergenic. However, some breeds are less
        likely to trigger allergies and are considered more hypoallergenic.
        Poodles are one example of such breeds. Poodles have a double layered
        coat comprised of a curly outer coat and a soft undercoat. The curly
        outercoat traps the dog's dander, stopping its release into air. Also,
        Poodles have hair instead of fur, which is less likely to shed. This
        combination makes Poodles less allergen-producing than other breeds.
        These hair qualities can be inherited by Poodle hybris, and so many
        Doodle breeds are considered hypoallergenic.
      </p>
    )
  },
  {
    title: 'What’s a Double Doodle Puppy?',
    text: (
      <p className={styles.text}>
        A{' '}
        <a
          className={styles.link}
          href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/double-doodle`}
        >
          Double Doodle
        </a>{' '}
        refers to a cross between two Doodle breeds. For example, if a
        Goldendoodle and Labradoodle are bred, their offspring are considered
        Double Doodle puppies. Double Doodles may inherit some of the best
        characteristics of their Doodle parents, such as high intelligence,
        playfulness, and a low-shedding coat. Double Doodle puppies can be a
        good choice for people looking for intelligent and low-shedding
        companion dogs.
      </p>
    )
  },
  {
    title: 'How Much Do Doodle Puppies Cost?',
    text: (
      <p className={styles.text}>
        Doodle puppies for sale are typically priced between $1,000 and $3,500
        by reputable breeders. However, the exact price will depend on the breed
        mixture, age of the puppy, experience of the breeder, and your location.
        In general, smaller Doodles tend to be more expensive than larger ones
        given high demand for them.
        <br />
        <br />
        It can be more affordable to adopt a Doodle dog from an animal shelter
        or rescue. However, adopted pets can sometimes have medical or
        behavioral issues that may require veterinary attention or training.
        These can take on additional costs. Whether adopting or buying, you
        should be prepared for ongoing expenses with your pup which can add up
        to thousands of dollars annually. These includes food, toys, medical
        care, and grooming services. For more information on Doodle costs, check
        out our guide on{' '}
        <a
          className={styles.link}
          href={`${process.env.NEXT_PUBLIC_ROOT_URL}/blog/doodle-dog-price`}
        >
          doodle dog prices.
        </a>
      </p>
    )
  },
  {
    title: 'Can Doodles Be Registered?',
    text: (
      <p className={styles.text}>
        As a mixed breed, Doodles are typically not recognized by major kennel
        clubs. This includes the American Kennel Club (AKC) or the Kennel Club
        of the UK. Your Doodle puppy can therefore not be registered with these
        registries. However, some Doodle registries have been created by
        breeders or people passionate about maintaining health and standards of
        a specific mixed Doodle breed. One example is the{' '}
        <a className={styles.link} href='https://americandoodleregistry.com/'>
          American Doodle Registry.
        </a>{' '}
        Another example is the{' '}
        <a
          className={styles.link}
          href='https://www.goldendoodleassociation.com/'
        >
          Goldendoodle Association of North America
        </a>{' '}
        which is a breed-specific registry dedicated to Goldendoodles. Such
        registries are a good opportunity to meet owners of the same Doodle
        breed and to get support on raising your pup.
      </p>
    )
  },
  {
    title: 'What Is the Friendliest Doodle Breed?',
    text: (
      <p className={styles.text}>
        Each Doodle breed has its unique personality given the temperaments of
        the breeding parents. Poodles are generally known for their friendly
        natures and when mixed with other friendly breeds such as Golden
        Retrievers or Cavalier King Charles Spaniels, the resulting Doodle
        breeds can be very loving and affectionate puppies. Some of the
        friendliest Doodle breeds include the Labradoodle, Goldendoodle,
        <a
          className={styles.link}
          href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/bernedoodle`}
        >
          Bernedoodle,
        </a>{' '}
        and{' '}
        <a
          className={styles.link}
          href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/cavapoo`}
        >
          Cavapoo.
        </a>{' '}
        These breeds are generally known for being not only friendly with
        adults, but with children and other pets as well. Though many Doodle
        breeds are known for their friendly dispositions, the best way to find
        the friendliest Doodle for you is to spend time with the puppy and see
        if he or she feels right for your family.
      </p>
    )
  },
  {
    title: 'What is an F1 vs. F2 Doodle?',
    text: (
      <p className={styles.text}>
        Doodles are typically categorized into a few groups depending on their
        heritage. These categories include F1 Doodles, F1B Doodles, and F2
        Doodles. An F1 Doodle is a firs generation Doodle that is a cross
        between a purebred Poodle and another purebred dog. F1B Doodles are
        crosses between purebred Poodles and other Doodles. F2 Doodles result
        from a combining two equivalent Doodle breeds (e.g. mixture of two
        Goldendoodles). F1 Doodles are considered to be the most predictable in
        terms of looks and temperament, given that they result from two
        well-defined breeds. This variability increases with F1B Doodles and
        even more so with F2 Doodles, given that the genetic makeup of the puppy
        increases in these types. However, the exact looks and temperament of
        your puppy will depend primarily on the breeding parents, so it's
        important to spend time with the breeding parents before choosing a
        puppy.
      </p>
    )
  },
  {
    title: 'How Do I Find a Reputable Doodle Breeder?',
    text: (
      <p className={styles.text}>
        Finding a Doodle breeder that is experienced and reputable is the first
        step to bringing home a healthy and happy puppy. Here are some steps to
        consider as you search for the right Doodle breeder:
        <br />
        <br />
        <ol>
          <li>
            Research Doodle breeds to find the right one that is a match for
            your lifestyle and preferences.
          </li>
          <li>
            Ask friends, family, and veterinarians for recommendations of
            trustworthy Doodle breeders.
          </li>
          <li>
            Contact national breed organizations or local Doodle breed clubs and
            ask for a list of reputable Doodle breeders in your area.
          </li>
          <li>
            Check for breeders on vetting websites that have screened and
            selected reputable breeders (e.g. Mawoo Pets)
          </li>
          <li>
            Once you have selected a breeder, pay a visit to their home or
            facility. Ensure that the facility is clean and well-maintained.
          </li>
          <li>
            Ask the breeder about the genetic history of the breeding parents
            and for proof of health clearances or medical checks on their puppy
            and parents.
          </li>
          <li>
            Ask a lot of questions to understand the breeder's experience,
            practices, and breeding philosophy.
          </li>
        </ol>
        <br />
        Following these steps helps you ensure that you are finding a reputable
        and trustworthy Doodle breeder. If you are unsure about a breeder or
        his/her practices, don't be afraid to walk away. At Mawoo Pets, we have
        vetted 1,000 responsible breeders who follow strict health, safety, and
        socialization standards for their pups. Contact our team to learn more
        about our Doodle breeders, and to find the right Doodle puppy locally or
        nationwide for your home.
      </p>
    )
  }
]
export const doodleImages = [
  {
    img: dogImgOne,
    alt: 'Goldendoodle puppy playing fetch in the beach.'
  },
  {
    img: dogImgTwo,
    alt: 'The prettiest Bernedoodle puppy resting in the park.'
  },
  {
    img: dogImgThree,
    alt: 'Chocolate Labradoodle dog smiling at the camera in an autumn park.'
  },
  {
    img: dogImgFour,
    alt: 'Cute miniature doodle dog being held by a woman with a yellow cardigan.'
  }
]

// MINI

export const miniImages = [
  {
    img: miniImgOne,
    alt: ' Woman hugging and kissing her toy poodle. '
  },
  {
    img: miniImgTwo,
    alt: 'Miniature Dachshund taking a ride in the car.'
  },
  {
    img: miniImgThree,
    alt: 'Yorkshire Terrier duo wearing matching harnesses while staring at the camera.'
  },
  {
    img: miniImgFour,
    alt: 'Cute miniature Chihuahua sitting on the lap of a woman at a restaurant.'
  }
]

export const miniParagraphs = [

  {
    title: 'What types of miniature dogs do you have for sale?',
    text: (
      <p className={styles.text}>
        Our selection of miniature dogs includes a wide range of breeds such as: Yorkshire Terrier, French Bulldog, Miniature Pinscher, Pomeranian, <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/dachshund`}>Dachshund</a>, and many more. Here are some of the <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/blog/15-most-popular-small-dog-breeds`}>most popular small dog breeds</a> that we have available at Mawoo Pets.
      </p>
    )
  },
  {
    title: 'What are your most popular mini dog breeds available for sale?',
    text: (
      <p className={styles.text}>
        The most popular mini dog breeds we offer include the <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/french-bulldog`}>French Bulldog</a>, <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/yorkshire-terrier`}>Yorkshire Terrier</a>, and Toy Poodle mixes (e.g., Yorkipoo, Maltipoo, Chi-Poo). These breeds are particularly loved for their unique temperaments and affectionate personalities.
      </p>
    )
  },
  {
    title: 'What are the health considerations for mini dogs?',
    text: (
      <p className={styles.text}>
        Mini dogs have some specific health considerations. Common issues for them include dental problems given their small mouths, susceptibility to cold weather, and genetic health issues like heart murmurs and luxating patellas (kneecap difficulties). Keep an eye out for these issues in your small breed dog and don't forget to pay consistent visits to your veterinarian!
      </p>
    )
  },
  {
    title: 'How can I make sure a tiny dog is the right pet for my family?',
    text: (
      <p className={styles.text}>
        Each small dog breed is different. Before bringing home a puppy, you should research the breed's energy level, temperament, grooming needs, and how well it can adapt to your living situation. Also, tiny dogs can require more attention and can suffer from separation anxiety, so consider that in your evaluation when choosing the right breed for you.
      </p>
    )
  },
  {
    title: 'Are mini dogs suitable for families with children?',
    text: (
      <p className={styles.text}>
        This varies by breed. Some mini dogs like Chihuahuas are not good with kids. They can feel threatened by them and may respond with aggression. Other breeds like Shih Tzus and Beagles <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/kid_friendly`}>are excellent (patient!) with kids</a>. They enjoy play and rarely ever show aggression. Keep in mind that whatever breed you bring home, it's important to teach your kids gentle handling of your small pup as miniature dogs can be more fragile.
      </p>
    )
  },
  {
    title: 'How long do mini dogs typically live?',
    text: (
      <p className={styles.text}>
        Mini dogs typically have a longer lifespan than larger breeds. On average, they live from 12 to 15 years, with some toy breeds reaching 18 or even 20 years of age. So if you're in search of a long-term companion, a miniature dog breed can make an excellent choice.
      </p>
    )
  },
  {
    title: 'What is the smallest dog breed you offer for sale?',
    text: (
      <p className={styles.text}>
        The <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/chihuahua`}>Chihuahua</a> is the smallest dog breed that we offer. This adorable toy breed is known for its big personality as much as its tiny size. Chihuahuas are a popular choice for those seeking a compact companion.
      </p>
    )
  },
  {
    title: 'Do small dog breeds require special care?',
    text: (
      <p className={styles.text}>
        Yes. Small dog breeds require more careful feeding to avoid obesity (they can more easily be over-fed), regular dental care, and protection from harsh weather conditions.
      </p>
    )
  },
  {
    title: 'What are the exercise needs of a tiny dog?',
    text: (
      <p className={styles.text}>
        Tiny dogs generally require less physical exercise than larger breeds. This is part of what makes them <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/blog/best-apartment-dogs`}>suitable for apartment living</a>. But some miniature breeds like Jack Russell Terriers are <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/active`}>very active</a> and need a lot of daily exercise. In general, you should plan for daily walks, playtime, and indoor activity to keep your puppy happy and healthy.
      </p>
    )
  },
  {
    title: 'What are the personality traits of small puppy breeds?',
    text: (
      <p className={styles.text}>
        Small puppy breeds are usually playful, affectionate, and <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/blog/smartest-small-dogs`}>intelligent</a>. Some are more sociable while others are more reserved - this depends on the breed. Small breed dogs can also be more attached to their primary owner and may demand more attention.
      </p>
    )
  },
  {
    title: 'What should I expect in the first few months with a little puppy? ',
    text: (
      <p className={styles.text}>
        The <a className={styles.link} href='https://ppies-get-easier'>first 6 months with a new small puppy</a> can be difficult. Adjustment is required as your pup gets used to her new home. You'll also have to think about potty training, teething, training (basic obedience commands), and socialization. In the first few months, puppies are curious and playful but also easily tire themselves out and require plenty of rest. Two other things to keep in mind are teething (i.e., have chew toys ready) and regular veterinary check-ups to monitor your pup's health in this critical period.
      </p>
    )
  }
]

// AFFORDABLE

export const affordableParagraphs = [

  {
    title: 'Can I find puppies for sale under 1,000 dollars?',
    text: (
      <p className={styles.text}>
        Yes, we have budget-friendly puppies available priced under $1,000. Our hope is to make it easier for all to find a loving yet affordable puppy companion.
      </p>
    )
  },
  {
    title: 'Are there affordable puppies for sale near me?',
    text: (
      <p className={styles.text}>
        Yes — we have listings of available puppies across the United States and Canada. You can search by location (zip or postal code) to find the perfect puppy near you. Once you find the right match, select "pickup" at checkout and we'll arrange for you to pickup your puppy directly from the breeder.
      </p>
    )
  },
  {
    title: 'What types of dogs under 1,000 dollars do you have available?',
    text: (
      <p className={styles.text}>
        There's a fairly wide mix! Breeds range from small to large including: Pomapoo, <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/goldendoodle`}>Goldendoodle</a>, <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/catahoula-leopard-dog`}>Catahoula Leopard Dog</a>, and more! Our selection includes diverse breeds of dogs catering to different lifestyles and preferences.
      </p>
    )
  },
  {
    title: 'Do you offer affordable puppies for sale in MA under $1,000?',
    text: (
      <p className={styles.text}>
        Yes, of course. To find <a className={styles.link} href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/massachusetts`}>puppies for sale in MA</a> under $1,000, filter our available puppies by state; or by entering your ZIP code in massachusetts in our search bar.
      </p>
    )
  },
  {
    title: 'Are your affordable puppies healthy and well-cared for?',
    text: (
      <p className={styles.text}>
        All our puppies for sale, regardless of their price, are from reputable breeders. Our breeders have been screened for their reputation, experience, and breeding standards, and so you can be sure that when purchasing from Mawoo Pets, that your puppy is healthy and well-cared for.
      </p>
    )
  }
]

export default function AboutCategories ({ paragraphs, images }) {
  const memoizedParagraphs = useMemo(() => paragraphs, [paragraphs])
  const memoizedImages = useMemo(() => images, [images])

  return (
    <div className={styles.article}>
      {
        memoizedParagraphs?.map((paragraph, i) => {
          return (
            <div key={i}>
              <Section data={paragraph} isFirst={i === 0} />
            </div>
          )
        }
        )
    }
      <section className={styles.gallery}>
        {memoizedImages?.map((image, i) => {
          return (
            <div key={i}>
              <Image
                src={image.img}
                layout='intrinsic'
                alt={image.alt}
                loading='lazy'
                placeholder='blur'
                blurDataURL={`/_next/image?url=${image}&w=16&q=1`}
              />
            </div>
          )
        })}
      </section>
    </div>
  )
}
